function resolveLocalApiUrl(value) {
  const hostname = globalThis.location?.hostname
  const loopbackHosts = ['localhost', '127.0.0.1']
  if (!import.meta.env.DEV || !loopbackHosts.includes(hostname)) return value
  try {
    const url = new URL(value)
    if (url.protocol !== 'http:' || !loopbackHosts.includes(url.hostname) || url.hostname === hostname) return value
    // Different loopback aliases are different cookie sites. Preserve the
    // configured API port/path while matching the local page's hostname.
    url.hostname = hostname
    return !value.endsWith('/') && url.pathname === '/' && !url.search && !url.hash
      ? url.href.slice(0, -1) : url.href
  } catch {
    return value
  }
}

export const API_BASE_URL = resolveLocalApiUrl(import.meta.env.VITE_API_BASE_URL || import.meta.env.API_BASE_URL || 'http://localhost:8000')
export const ASSISTANT_URL = import.meta.env.VITE_ASSISTANT_URL || 'http://localhost:8001'
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''

export const parseBooleanEnvFlag = (rawValue, defaultValue = false) => {
  const value = String(rawValue ?? '').trim().toLowerCase()
  if (!value) return defaultValue
  if (['1', 'true', 't', 'yes', 'y', 'on'].includes(value)) return true
  if (['0', 'false', 'f', 'no', 'n', 'off'].includes(value)) return false
  return defaultValue
}

export const IS_SUBSCRIPTION_OPTIONAL = parseBooleanEnvFlag(
  import.meta.env.IS_SUBSCRIPTION_OPTIONAL ?? import.meta.env.VITE_IS_SUBSCRIPTION_OPTIONAL,
  false,
)

export const IS_DEBUG_CHAT_ENABLED = parseBooleanEnvFlag(
  import.meta.env.VITE_DEBUG ?? import.meta.env.DEBUG,
  false,
)

export const IS_NEXO_DISCOVERY_ENABLED = parseBooleanEnvFlag(
  import.meta.env.VITE_NEXO_DISCOVERY_ENABLED,
  false,
)
